module.exports = __webpack_public_path__ + "media/assets/images/icons/resource-generic/file-small-51770802d64b797cfab7a6fd8896e611.png";